module.exports = __webpack_public_path__ + "static/award1-b04be37f0572ba94b670d83ed22a73b2.png";